import React from 'react';
import styled from 'styled-components';
import styles from './Menu.module.scss';
import { CustomNavItem } from '../CustomNavItem';
import { useLocation, useNavigate } from 'react-router-dom';
import { NAV_ITEMS, activeNavTitle } from '../Sidebar/navItems';
import { useAppSelector } from 'hooks';
import {
  pendingPhotosCountSelect,
  pendingProvidersCountSelect,
} from 'state/selectors/doctorSelectors';

/**
 * The off-canvas nav for viewports below the sidebar breakpoint.
 *
 * `display: flex` in a column, with the list as the one scrolling row, for the
 * same reason the sidebar is built that way: eleven items do not fit a short
 * window, and a panel that runs past the bottom of the screen with no scroll
 * hides whatever is at the end of it.
 */
const StyledMenu = styled.nav`
  background: white;
  border-right: 1px solid #d8d8d8;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(-100%)')};
  width: 256px;
  max-width: 85vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: left;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  transition: transform 0.3s ease-in-out;
  box-sizing: border-box;
`;

const Menu = ({ open }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Same source of truth as the desktop sidebar. Both used to keep their own
  // hand-written list and their own selection state, so this menu was missing
  // four sections outright and lit up a different item than the sidebar did.
  const selectedItem = activeNavTitle(pathname);

  // The same pending-approvals count the sidebar shows. It is read, not
  // fetched, here: the sidebar owns the request and both are mounted together,
  // so a second fetch would only duplicate it. Leaving it out meant the queue
  // was invisible to anyone working at a narrow width.
  const waitingCount =
    useAppSelector(pendingProvidersCountSelect) + useAppSelector(pendingPhotosCountSelect);

  return (
    <StyledMenu open={open} aria-label="Main" aria-hidden={!open}>
      <div className={styles.itemsContainer}>
        {NAV_ITEMS.map(item => (
          <CustomNavItem
            key={item.title}
            onSelect={() => navigate(item.route)}
            selectedItem={selectedItem}
            title={item.title}
            icon={item.icon(selectedItem === item.title)}
            badgeCount={item.showsPendingBadge ? waitingCount : undefined}
          />
        ))}
      </div>
    </StyledMenu>
  );
};

export default Menu;
